/**
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: valeriaplutino
 * Created: 29/9/21
 */

import * as React from 'react';
import { Box, HStack } from '@chakra-ui/react';
import { NavigationButton } from '../NavigationButton';
import { useAssignment } from '@/components/contexts/AssignmentContext/useAssignment';
import { useAuth } from '@/components/auth/useAuth';
import { showNavigation } from '@/routes/navigation';

export const NavigationBar = () => {
    const { authState } = useAuth();
    const { currentAssignment, user } = useAssignment();

    const navigationRoutes = showNavigation(
        user?.isSupervisor,
        !!currentAssignment?.isGlobalAdmin ||
            !!currentAssignment?.adminFaculties?.length ||
            !!currentAssignment?.adminOrganisations?.length,
    );

    return authState.isAuthenticated ? (
        <Box bgColor={'gray.200'} p={6} pb={0}>
            <>
                <HStack spacing={4} as="nav" role="navigation" bgColor="white" p={4}>
                    {navigationRoutes.map((route) => {
                        return <NavigationButton {...route} key={route.key} />;
                    })}
                </HStack>
            </>
        </Box>
    ) : null;
};
